import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button,
  CircularProgress, Alert, Stack,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import { httpClient } from "../../api/httpClient";
import { API_ORIGIN } from "../../api/config";

// Endpoint backend : POST /api/admin/mail/test?to=...
// (monté sur /api/admin/mail, sans /v1 — on prend l'origin de API_BASE_URL).
const TestMailTool = () => {
  const [to, setTo] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const send = async () => {
    if (!to.trim()) return;
    setLoading(true);
    try {
      const url = `${API_ORIGIN}/api/admin/mail/test?to=${encodeURIComponent(to)}`;
      const { json } = await httpClient(url, { method: "POST" });
      if (json && json.success === false) {
        notify(`Erreur SMTP : ${json.message || json.error}`, { type: "error" });
      } else {
        notify(json?.message || "Email envoyé", { type: "success" });
      }
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <EmailIcon /> Test mail
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Envoie un mail de test pour vérifier la configuration SMTP. Le sujet et le corps sont définis côté serveur.
      </Alert>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <TextField
              fullWidth size="small" label="Destinataire" type="email"
              value={to} onChange={(e) => setTo(e.target.value)}
            />
            <Box>
              <Button variant="contained" onClick={send} disabled={loading || !to.trim()}>
                {loading ? <CircularProgress size={20} /> : "Envoyer le mail de test"}
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: TestMailTool };
